<div class="app-content-new" [class.logged-in]="showNav">
  <router-outlet></router-outlet>
  <app-bottom-nav *ngIf="showNav"></app-bottom-nav>
  <app-side-nav *ngIf="showNav"></app-side-nav>
</div>
<!-- Temporarily disabled: reported bugs (stale address after re-saving email, possible
     validation glitch on Settings). See changelog/2026-07-20-disable-email-confirmation-feature.md.
     Re-enable by uncommenting this and the EmailConfirmationBannerComponent registration in
     app.module.ts, and the SendConfirmationEmailAsync call sites in AccountController.cs. -->
<!-- <app-email-confirmation-banner></app-email-confirmation-banner> -->
<app-nova-insight-widget></app-nova-insight-widget>
<!-- FLIP-316: app-nova-companion-fab moved into app-bottom-nav's template so its mobile "tab"
     state can dock flush against the nav's real box instead of calculating a matching position
     independently (see bottom-nav.component.scss). Safe to gate on the same *ngIf="showNav" as
     the nav itself: NovaCompanionFabComponent.showFab already requires the identical
     isUserLoggedIn / isOnboardingComplete / isConfirmedActive conditions as app.component's
     showNav, so nothing that used to show the FAB can now be hidden by this. -->
